<div class="p-dialog-content__dynamic">
  
  <div class="email-value">
    <label>Sent To</label>
    <p>{{sentTo}}</p>
  </div>
  
  <div class="email-value">
    <label>Sent At</label>
    <p>{{sentAt}}</p>
  </div>

  <div class="email-value">
    <label>Email Title At</label>
    <p>{{emailTitle}}</p>
  </div>

  <div class="email-value">
    <label>Email Content</label>
    <p [innerHTML]="emailContent"></p>
  </div>
</div>

<div class="p-dialog-footer p-dialog-footer__dynamic">
  <button class="regular-btn medium" (click)="close()">
    Close
  </button>
</div>
